import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectHostDetail, selectAssetDetailId, selectHostWorkspace } from 'store/Contextualization/AssetDetail/selectors';
import debounce from 'lodash/debounce';
import { updateHost } from 'store/Host/actions';
import { Wrapper, InputTitle, IconHost } from './styled';
import { selectReadOnly } from 'store/Faraday/selectors';
import { updateHostGeneral } from 'store/HostsGeneral/actions';

const Title = ({ assetsGeneral }) => {
  const dispatch = useDispatch();
  const hostDetail = useSelector(selectHostDetail);
  const hostId = useSelector(selectAssetDetailId);
  const [hostIp, setHostIp] = useState(hostDetail.ip);
  const readOnly = useSelector(selectReadOnly);
  const disabled = !assetsGeneral && readOnly;
  const workspace = useSelector(selectHostWorkspace);

  useEffect(() => {
    setHostIp(hostDetail.ip);
  }, [hostDetail]);

  const updateIp = useRef(debounce((ip) => {
    if (ip) {
      assetsGeneral ? dispatch(updateHostGeneral(hostId, { ip }, workspace)) : dispatch(updateHost(hostId, { ip }));
    }
  }, 1000));

  const handleChange = (e) => {
    const ip = e.target.value;
    setHostIp(ip);
    updateIp.current(ip);
  };

  return (
    <Wrapper>
      <IconHost />
      <InputTitle value={ hostIp } onChange={ handleChange } disabled={ disabled } />
    </Wrapper>
  );
};

export default Title;
